import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=ef30de32&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef30de32')) {
      api.createRecord('ef30de32', component.options)
    } else {
      api.reload('ef30de32', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=ef30de32&", function () {
      api.rerender('ef30de32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/Tab.vue"
export default component.exports